export default "__VITE_ASSET__CPV8hfOe__"